
import { Component, Vue, Watch } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { LogMixin } from "@/plugins/error.ts";
import netFail from '@/views/exception/netFail.vue'
import { getStoreInfo } from '@/api/ccx'
import { getSyDictDataInfo } from '@/api/commonConfig'

@Component({
  mixins: [LogMixin],
  components: { netFail }
})
export default class App extends Vue {
  @Getter includedComponents: string[]
  @Action setIncludedComponents!: (val: string[]) => void;
  @Getter loading!: number
  @Getter companyId!: string
  @Getter userId!: string
  @Getter mobile!: string
  include = []
  netError = false // 网络请求失败
  timer = null

  created() {
    this.$store.commit('CLEAR_LOADING')
    this.$log.setLog({
      file: 'App.vue',
      name: 'created方法',
      type: '进入页面'
    })
    this.include = this.includedComponents
    // this.addListener()
    // console.log('app created ***', this.$route.name, this.$route.query)
    this.companyId && getStoreInfo({ storeId: this.companyId }).then((res) => {
      let storeData = res?.data || {}
      const { pickupStartTime, pickupEndTime, takeStartTime, takeEndTime } =
        storeData
      // 去掉时间字符串中的秒
      const formatTime = (time: string) => time?.replace(/:00$/, '') || ''
      storeData = {
        ...storeData,
        pickupStartTime: formatTime(pickupStartTime),
        pickupEndTime: formatTime(pickupEndTime),
        takeStartTime: formatTime(takeStartTime),
        takeEndTime: formatTime(takeEndTime)
      }
      this.$store.commit('SET_CCX_STORE', storeData)
    })
    this.userId && this.dictList()
  }

  dictList () {
    let param = {
      dictTypeId: 'goodsH5Share'
    }
    getSyDictDataInfo(param).then(res => {
      this.$store.commit('SET_SFTP_URL', res.data[0].dataName)
    })
  }

  addListener () {
    window.addEventListener('online', this.updateOnlineStatus)
    window.addEventListener('offline', this.updateOnlineStatus)
  }

  updateOnlineStatus(e: any) {
    // console.log('app updateOnlineStatus e.type', e.type, this.$route.name)
    if (e.type === 'offline' && (!this.$route.name || this.$route.name === 'ShopHome')) this.netError = true
  }

  reload () {
    this.$log.setLog({
      file: 'App.vue',
      name: 'reload方法',
      type: '函数执行'
    })
    // console.log('app reload ***', this.$route.name)
    if (this.$route.name) window.location.reload()
    else this.$router.replace('/shopHome')
  }

  @Watch('includedComponents')
  changeInclude(val: string[]) {
      this.include = val
  }

  @Watch('$route')
  routeChange(to, from) {
      this.$log.setLog({
        file: 'App.vue',
        name: 'routeChange方法',
        type: '函数执行'
      })
      console.log('routeChange', this.$route.meta.permission)
      // 如果要to(进入)的页面是需要keepAlive缓存的，把name push进include数组中
      if (to.meta.keepAlive) {
          !this.include.includes(to.name) && this.include.push(to.name);
      }
      // 如果 要 form(离开) 的页面是 keepAlive缓存的，
      // 再根据 deepth 来判断是前进还是后退
      // 如果是后退：
      if (from.meta.keepAlive && to.meta.deepth < from.meta.deepth) {
          const index = this.include.indexOf(from.name);
          index !== -1 && this.include.splice(index, 1);
      }
      this.setIncludedComponents(this.include)
      // 首页，产业商城订单页面弹出签约华润弹框
      const showRoutes = ['ShopMallOrder','Mall']
      let params = { companyId: this.companyId, mobile: this.mobile }
      if(showRoutes.includes(to.name)) {
        this.$resultPopup.show({...params, routeName: to.name})
      }
  }

  @Watch('loading')
  loadingChange (val: number) {
    if (this.loading <= 0) {
      clearInterval(this.timer)
      console.log('调用原生清除动画')
      // 调用原生结束动画
      this.$bridge.callHandler('showLoadingAnimation', {show: '0'})
    } else {
      console.log('调用原生动画开启')
      // 调用原生开启动画
      this.$bridge.callHandler('showLoadingAnimation', {show: '1'})
      // 启用加载动画后30秒后不消失，强制取消动画
      this.timer = setInterval(() => {
        this.$store.commit('CLEAR_LOADING')
      }, 30000)
    }
  }
}
